const mutations = {
  SET_PARTNERS(state, payload) {
    state.partners = payload;
  },
  SET_PARTNER(state, payload) {
    state.partner = payload;
  },
};

export default mutations;
